import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material.module';
import { TranslateModule } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { IpdActiveListComponent } from './ipd-active-list/ipd-active-list.component';
import { BedOccupancyComponent } from './bed-occupancy/bed-occupancy.component';

@Component({
  selector: 'app-ipd-management',
  standalone: true,
  imports: [
    CommonModule,
    MaterialModule,
    TranslateModule,
    TablerIconsModule,
    IpdActiveListComponent,
    BedOccupancyComponent
  ],
  templateUrl: './ipd-management.component.html',
  styleUrls: ['./ipd-management.component.scss'],
})
export class IpdManagementComponent {
  selectedTabIndex = 0;
}
